// import React, { useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Divider,
// } from "@mui/material";
// import { CheckCircle, Cancel, Payment } from "@mui/icons-material";
// import "./index.scss";

// const PaymentOptionsModal = ({
//   open,
//   onClose,
//   onConfirm,
//   selectedVariant,
//   productDetail,
//   setCardType,
// }) => {
//   const [paymentOption, setPaymentOption] = useState("");
//   const [selectedInstallmentPlan, setSelectedInstallmentPlan] = useState("");

//   if (!selectedVariant || !productDetail) return null;

//   const getVariantPrice = () => {
//     if (!selectedVariant?.variant_detail) return "N/A";
//     const variantDetail = selectedVariant.variant_detail;
//     return (
//       variantDetail.discounted_price || variantDetail.original_price || "N/A"
//     );
//   };

//   const getInstallmentInfo = () => {
//     const commissionPlans =
//       selectedVariant?.variant_detail?.commission_installment_plans;
//     const allBankPlans =
//       selectedVariant?.variant_detail?.all_bank_installment_plans;

//     return {
//       commission: commissionPlans
//         ? {
//             asLowAs: commissionPlans.as_low_as,
//             plans: commissionPlans.plans || [],
//             processingFees: commissionPlans.processing_fees || [],
//           }
//         : null,
//       allBank: allBankPlans
//         ? {
//             asLowAs: allBankPlans.as_low_as,
//             plans: allBankPlans.plans || [],
//             processingFees: allBankPlans.processing_fees || [],
//           }
//         : null,
//     };
//   };

//   const handlePaymentOptionChange = (event) => {
//     const option = event.target.value;
//     setPaymentOption(option);
//     if (option === "full") {
//       setSelectedInstallmentPlan("");
//     }
//   };

//   const handleInstallmentPlanChange = (event, planType) => {
//     setSelectedInstallmentPlan(event.target.value);
//     setCardType(planType === "allBank" ? "all_bank_plans" : "bafl_plans");
//   };

//   const handleConfirm = () => {
//     if (paymentOption === "full") {
//       onConfirm({
//         variant: selectedVariant,
//         isBnpl: false,
//         installmentPlan: null,
//       });
//     } else if (paymentOption === "bnpl" && selectedInstallmentPlan) {
//       onConfirm({
//         variant: selectedVariant,
//         isBnpl: true,
//         installmentPlan: selectedInstallmentPlan,
//       });
//     }
//   };

//   const isConfirmDisabled = () => {
//     if (paymentOption === "full") return false;
//     if (paymentOption === "bnpl") return !selectedInstallmentPlan;
//     return true;
//   };

//   const installmentInfo = getInstallmentInfo();

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="md"
//       fullWidth
//       className="b2b-payment-options-modal"
//       PaperProps={{
//         className: "b2b-modal-paper",
//       }}
//     >
//       <DialogTitle className="b2b-modal-header">
//         <Box className="b2b-header-content">
//           <Payment color="primary" />
//           <Typography variant="h5" component="div" className="b2b-modal-title">
//             Choose Payment Option
//           </Typography>
//         </Box>
//         <Typography variant="body2" className="b2b-modal-subtitle">
//           Select how you would like to pay for this product
//         </Typography>
//       </DialogTitle>

//       <DialogContent className="b2b-modal-content">
//         {/* Product Summary */}
//         <Card className="b2b-product-summary-card">
//           <CardContent>
//             <Typography variant="h6" className="b2b-summary-title">
//               {productDetail.title}
//             </Typography>
//             <Typography variant="body2" className="b2b-summary-variant">
//               Variant: {selectedVariant.title}
//             </Typography>
//             <Typography variant="h6" className="b2b-summary-price">
//               PKR {getVariantPrice()}
//             </Typography>
//           </CardContent>
//         </Card>

//         {/* Payment Options */}
//         <RadioGroup
//           value={paymentOption}
//           onChange={handlePaymentOptionChange}
//           className="b2b-payment-options"
//         >
//           {/* Pay in Full Option */}
//           <Card
//             className={`b2b-payment-card ${
//               paymentOption === "full" ? "b2b-selected" : ""
//             }`}
//           >
//             <CardContent>
//               <FormControlLabel
//                 value="full"
//                 control={<Radio />}
//                 className="b2b-payment-radio"
//                 label={
//                   <Box className="b2b-payment-content">
//                     <Box className="b2b-payment-header">
//                       <Typography variant="h6" className="b2b-payment-title">
//                         Pay in Full
//                       </Typography>
//                     </Box>
//                     <Typography
//                       variant="body2"
//                       className="b2b-payment-description"
//                     >
//                       Pay the complete amount upfront with no additional fees
//                     </Typography>
//                     <Typography variant="h6" className="b2b-payment-amount">
//                       PKR {getVariantPrice()}
//                     </Typography>
//                   </Box>
//                 }
//               />
//             </CardContent>
//           </Card>

//           {/* Buy Now Pay Later Option */}
//           {(installmentInfo.commission || installmentInfo.allBank) && (
//             <Card
//               className={`b2b-payment-card ${
//                 paymentOption === "bnpl" ? "b2b-selected" : ""
//               }`}
//             >
//               <CardContent>
//                 <FormControlLabel
//                   value="bnpl"
//                   control={<Radio />}
//                   className="b2b-payment-radio"
//                   label={
//                     <Box className="b2b-payment-content">
//                       <Box className="b2b-payment-header">
//                         <Typography variant="h6" className="b2b-payment-title">
//                           Buy Now Pay Later
//                         </Typography>
//                       </Box>
//                       <Typography
//                         variant="body2"
//                         className="b2b-payment-description"
//                       >
//                         Split your payment into convenient monthly installments
//                       </Typography>

//                       {paymentOption === "bnpl" && (
//                         <Box className="b2b-installment-plans">
//                           {/* Commission Installment Plans */}
//                           {installmentInfo.commission && (
//                             <Box sx={{ mb: installmentInfo.allBank ? 3 : 0 }}>
//                               <Typography
//                                 variant="h6"
//                                 sx={{
//                                   color: "#1976d2",
//                                   fontWeight: "bold",
//                                   mb: 1,
//                                 }}
//                               >
//                                 Commission Plans
//                               </Typography>
//                               <Typography
//                                 variant="body1"
//                                 className="b2b-payment-highlight"
//                                 sx={{ mb: 2 }}
//                               >
//                                 As low as: {installmentInfo.commission.asLowAs}
//                               </Typography>
//                               <RadioGroup
//                                 value={selectedInstallmentPlan}
//                                 // onChange={handleInstallmentPlanChange}
//                                 onChange={(e) =>
//                                   handleInstallmentPlanChange(e, "commission")
//                                 }
//                                 className="b2b-plans-list"
//                               >
//                                 {installmentInfo.commission.plans.map(
//                                   (plan, index) => (
//                                     <FormControlLabel
//                                       key={`commission-${index}`}
//                                       value={plan}
//                                       control={<Radio size="small" />}
//                                       label={plan}
//                                       className="b2b-plan-option"
//                                     />
//                                   )
//                                 )}
//                               </RadioGroup>

//                               {installmentInfo.commission.processingFees
//                                 .length > 0 && (
//                                 <Box
//                                   className="b2b-processing-fees"
//                                   sx={{ mt: 2 }}
//                                 >
//                                   <Typography
//                                     variant="subtitle2"
//                                     className="b2b-fees-title"
//                                   >
//                                     Processing Fees:
//                                   </Typography>
//                                   {installmentInfo.commission.processingFees.map(
//                                     (fee, index) => (
//                                       <Typography
//                                         key={index}
//                                         variant="body2"
//                                         className="b2b-fee-item"
//                                       >
//                                         • {fee.plan}: {fee.fees}
//                                       </Typography>
//                                     )
//                                   )}
//                                 </Box>
//                               )}
//                             </Box>
//                           )}

//                           {/* All Bank Installment Plans */}
//                           {installmentInfo.allBank && (
//                             <Box>
//                               <Typography
//                                 variant="h6"
//                                 sx={{
//                                   color: "#d32f2f",
//                                   fontWeight: "bold",
//                                   mb: 1,
//                                 }}
//                               >
//                                 All Bank Plans
//                               </Typography>
//                               <Typography
//                                 variant="body1"
//                                 className="b2b-payment-highlight"
//                                 sx={{ mb: 2 }}
//                               >
//                                 As low as: {installmentInfo.allBank.asLowAs}
//                               </Typography>
//                               <RadioGroup
//                                 value={selectedInstallmentPlan}
//                                 // onChange={handleInstallmentPlanChange}
//                                 onChange={(e) =>
//                                   handleInstallmentPlanChange(e, "allBank")
//                                 }
//                                 className="b2b-plans-list"
//                               >
//                                 {installmentInfo.allBank.plans.map(
//                                   (plan, index) => (
//                                     <FormControlLabel
//                                       key={`allbank-${index}`}
//                                       value={plan}
//                                       control={<Radio size="small" />}
//                                       label={plan}
//                                       className="b2b-plan-option"
//                                     />
//                                   )
//                                 )}
//                               </RadioGroup>
//                             </Box>
//                           )}
//                         </Box>
//                       )}
//                     </Box>
//                   }
//                 />
//               </CardContent>
//             </Card>
//           )}
//         </RadioGroup>

//         {!installmentInfo.commission && !installmentInfo.allBank && (
//           <Typography className="b2b-no-installments-message">
//             Only full payment is available for this product
//           </Typography>
//         )}
//       </DialogContent>

//       <Divider />

//       <DialogActions className="b2b-modal-actions">
//         <Button
//           onClick={onClose}
//           variant="outlined"
//           color="secondary"
//           startIcon={<Cancel />}
//           className="b2b-cancel-button"
//         >
//           Back
//         </Button>
//         <Button
//           onClick={handleConfirm}
//           variant="contained"
//           color="primary"
//           startIcon={<CheckCircle />}
//           disabled={isConfirmDisabled()}
//           className="b2b-confirm-button"
//         >
//           Confirm Selection
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default PaymentOptionsModal;

import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Card,
  CardContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Chip,
} from "@mui/material";
import { CheckCircle, Cancel, Payment } from "@mui/icons-material";
import "./index.scss";

const PaymentOptionsModal = ({
  open,
  onClose,
  onConfirm,
  selectedVariant,
  productDetail,
  setCardType,
  selectedInterestRate,
  setSelectedInterestRate,
}) => {
  const [paymentOption, setPaymentOption] = useState("");
  const [selectedInstallmentPlan, setSelectedInstallmentPlan] = useState("");

  if (!selectedVariant || !productDetail) return null;

  const getVariantPrice = () => {
    if (!selectedVariant?.variant_detail) return "N/A";
    const variantDetail = selectedVariant.variant_detail;
    return (
      variantDetail.discounted_price || variantDetail.original_price || "N/A"
    );
  };

  const getInstallmentInfo = () => {
    const commissionPlans =
      selectedVariant?.variant_detail?.commission_installment_plans;
    const allBankPlans =
      selectedVariant?.variant_detail?.all_bank_installment_plans;

    return {
      commission: commissionPlans
        ? {
            asLowAs: commissionPlans.as_low_as,
            plans: commissionPlans.plans || [],
            processingFees: commissionPlans.processing_fees || [],
          }
        : null,
      allBank: allBankPlans
        ? {
            asLowAs: allBankPlans.as_low_as,
            plans: allBankPlans.plans || [],
            processingFees: allBankPlans.processing_fees || [],
          }
        : null,
    };
  };

  const handlePaymentOptionChange = (event) => {
    const option = event.target.value;
    setPaymentOption(option);
    if (option === "full") {
      setSelectedInstallmentPlan("");
      if (setSelectedInterestRate) {
        setSelectedInterestRate(null);
      }
    }
  };

  const handleInstallmentPlanChange = (event, planType) => {
    const selectedPlan = event.target.value;
    setSelectedInstallmentPlan(selectedPlan);
    setCardType(planType === "allBank" ? "all_bank_plans" : "bafl_plans");

    // Set interest rate for commission plans
    if (planType === "commission" && setSelectedInterestRate) {
      const installmentInfo = getInstallmentInfo();
      const commissionPlan = installmentInfo.commission?.plans?.find(
        (plan) => plan.installment_plan === selectedPlan
      );
      if (commissionPlan && commissionPlan.interest_rate) {
        setSelectedInterestRate(commissionPlan.interest_rate);
      }
    } else if (setSelectedInterestRate) {
      setSelectedInterestRate(null);
    }
  };

  const handleConfirm = () => {
    if (paymentOption === "full") {
      onConfirm({
        variant: selectedVariant,
        isBnpl: false,
        installmentPlan: null,
      });
    } else if (paymentOption === "bnpl" && selectedInstallmentPlan) {
      onConfirm({
        variant: selectedVariant,
        isBnpl: true,
        installmentPlan: selectedInstallmentPlan,
      });
    }
  };

  const isConfirmDisabled = () => {
    if (paymentOption === "full") return false;
    if (paymentOption === "bnpl") return !selectedInstallmentPlan;
    return true;
  };

  const installmentInfo = getInstallmentInfo();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className="b2b-payment-options-modal"
      PaperProps={{
        className: "b2b-modal-paper",
      }}
    >
      <DialogTitle className="b2b-modal-header">
        <Box className="b2b-header-content">
          <Payment color="primary" />
          <Typography variant="h5" component="div" className="b2b-modal-title">
            Choose Payment Option
          </Typography>
        </Box>
        <Typography variant="body2" className="b2b-modal-subtitle">
          Select how you would like to pay for this product
        </Typography>
      </DialogTitle>

      <DialogContent className="b2b-modal-content">
        {/* Product Summary */}
        <Card className="b2b-product-summary-card">
          <CardContent>
            <Typography variant="h6" className="b2b-summary-title">
              {productDetail.title}
            </Typography>
            <Typography variant="body2" className="b2b-summary-variant">
              Variant: {selectedVariant.title}
            </Typography>
            <Typography variant="h6" className="b2b-summary-price">
              PKR {getVariantPrice()}
            </Typography>
          </CardContent>
        </Card>

        {/* Payment Options */}
        <RadioGroup
          value={paymentOption}
          onChange={handlePaymentOptionChange}
          className="b2b-payment-options"
        >
          {/* Pay in Full Option */}
          <Card
            className={`b2b-payment-card ${
              paymentOption === "full" ? "b2b-selected" : ""
            }`}
          >
            <CardContent>
              <FormControlLabel
                value="full"
                control={<Radio />}
                className="b2b-payment-radio"
                label={
                  <Box className="b2b-payment-content">
                    <Box className="b2b-payment-header">
                      <Typography variant="h6" className="b2b-payment-title">
                        Pay in Full
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      className="b2b-payment-description"
                    >
                      Pay the complete amount upfront with no additional fees
                    </Typography>
                    <Typography variant="h6" className="b2b-payment-amount">
                      PKR {getVariantPrice()}
                    </Typography>
                  </Box>
                }
              />
            </CardContent>
          </Card>

          {/* Buy Now Pay Later Option */}
          {(installmentInfo.commission || installmentInfo.allBank) && (
            <Card
              className={`b2b-payment-card ${
                paymentOption === "bnpl" ? "b2b-selected" : ""
              }`}
            >
              <CardContent>
                <FormControlLabel
                  value="bnpl"
                  control={<Radio />}
                  className="b2b-payment-radio"
                  label={
                    <Box className="b2b-payment-content">
                      <Box className="b2b-payment-header">
                        <Typography variant="h6" className="b2b-payment-title">
                          Buy Now Pay Later
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        className="b2b-payment-description"
                      >
                        Split your payment into convenient monthly installments
                      </Typography>

                      {paymentOption === "bnpl" && (
                        <Box className="b2b-installment-plans">
                          {/* Commission Installment Plans */}
                          {installmentInfo.commission && (
                            <Box sx={{ mb: installmentInfo.allBank ? 3 : 0 }}>
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "#1976d2",
                                  fontWeight: "bold",
                                  mb: 1,
                                }}
                              >
                                Commission Plans
                              </Typography>
                              <Typography
                                variant="body1"
                                className="b2b-payment-highlight"
                                sx={{ mb: 2 }}
                              >
                                As low as: {installmentInfo.commission.asLowAs}
                              </Typography>
                              <RadioGroup
                                value={selectedInstallmentPlan}
                                onChange={(e) =>
                                  handleInstallmentPlanChange(e, "commission")
                                }
                                className="b2b-plans-list"
                              >
                                {installmentInfo.commission.plans.map(
                                  (plan, index) => (
                                    <FormControlLabel
                                      key={`commission-${index}`}
                                      value={plan.installment_plan}
                                      control={<Radio size="small" />}
                                      label={
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                          }}
                                        >
                                          <span>{plan.installment_plan}</span>
                                        </Box>
                                      }
                                      className="b2b-plan-option"
                                    />
                                  )
                                )}
                              </RadioGroup>

                              {installmentInfo.commission.processingFees
                                .length > 0 && (
                                <Box
                                  className="b2b-processing-fees"
                                  sx={{ mt: 2 }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    className="b2b-fees-title"
                                  >
                                    Processing Fees:
                                  </Typography>
                                  {installmentInfo.commission.processingFees.map(
                                    (fee, index) => (
                                      <Typography
                                        key={index}
                                        variant="body2"
                                        className="b2b-fee-item"
                                      >
                                        • {fee.plan}: {fee.fees}
                                      </Typography>
                                    )
                                  )}
                                </Box>
                              )}
                            </Box>
                          )}

                          {/* All Bank Installment Plans */}
                          {installmentInfo.allBank && (
                            <Box>
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "#d32f2f",
                                  fontWeight: "bold",
                                  mb: 1,
                                }}
                              >
                                All Bank Plans
                              </Typography>
                              <Typography
                                variant="body1"
                                className="b2b-payment-highlight"
                                sx={{ mb: 2 }}
                              >
                                As low as: {installmentInfo.allBank.asLowAs}
                              </Typography>
                              <RadioGroup
                                value={selectedInstallmentPlan}
                                onChange={(e) =>
                                  handleInstallmentPlanChange(e, "allBank")
                                }
                                className="b2b-plans-list"
                              >
                                {installmentInfo.allBank.plans.map(
                                  (plan, index) => (
                                    <FormControlLabel
                                      key={`allbank-${index}`}
                                      value={
                                        typeof plan === "string"
                                          ? plan
                                          : plan.installment_plan
                                      }
                                      control={<Radio size="small" />}
                                      label={
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                          }}
                                        >
                                          <span>
                                            {typeof plan === "string"
                                              ? plan
                                              : plan.installment_plan}
                                          </span>
                                          {typeof plan === "object" &&
                                            plan.interest_rate && (
                                              <Chip
                                                label={`${plan.interest_rate}% APR`}
                                                size="small"
                                                color="warning"
                                                variant="outlined"
                                              />
                                            )}
                                        </Box>
                                      }
                                      className="b2b-plan-option"
                                    />
                                  )
                                )}
                              </RadioGroup>
                            </Box>
                          )}
                        </Box>
                      )}
                    </Box>
                  }
                />
              </CardContent>
            </Card>
          )}
        </RadioGroup>

        {!installmentInfo.commission && !installmentInfo.allBank && (
          <Typography className="b2b-no-installments-message">
            Only full payment is available for this product
          </Typography>
        )}
      </DialogContent>

      <Divider />

      <DialogActions className="b2b-modal-actions">
        <Button
          onClick={onClose}
          variant="outlined"
          color="secondary"
          startIcon={<Cancel />}
          className="b2b-cancel-button"
        >
          Back
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          startIcon={<CheckCircle />}
          disabled={isConfirmDisabled()}
          className="b2b-confirm-button"
        >
          Confirm Selection
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentOptionsModal;
